import CreditCard from '../../src/legacy/CreditCard';
export default CreditCard;
